export const SettingRoutesList = {
  SETTINGS_BRANDING: 'branding',
  SETTINGS_BUSINESS_PROFILE: 'business-profile',
  SETTINGS_PAYOUTS: 'payouts',
  SETTINGS_PROFILE: 'my-profile',
};

export default SettingRoutesList;
